import axios from "axios";
import { apiRequest } from "@/services/api/apiClient.js";
import {ProductEntity} from "@/entities/ProductEntity.js";

const entity = new ProductEntity();

export async function getProducts({ page = 1, limit = 10, ...filters }) {
    return apiRequest({
        client: window.API_CONTRACT,
        method: "get",
        url:  entity.endpoints.list,
        params: { page, limit, ...filters },
    });
}

export async function getProductById({id}) {
    return apiRequest({
        client: window.API_CONTRACT,
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });
}
